import { Box, Grid, Typography, useTheme } from "@mui/material";
import KarenCoin from "../../../../../../../../media/images/icons/karenCoin.svg";
import ClockOutline from "../../../../../../../../media/images/icons/clock";
import ArrowLeftCircle from "../../../../../../../../media/images/icons/arrow-left-circle";
import Check3d from "../../../../../../../../media/images/icons/check3d.png";
import { Link } from "react-router-dom";

export default function MissionCard() {
  const theme = useTheme();
  return (
    <Grid
      container
      sx={{
        display: "flex",
        border: "1px solid gray",
        borderRadius: "16px",

        height: "100%",
      }}
    >
      <Grid item xs={3}>
        <Box
          sx={{
            height: "100%",
            backgroundColor: "info.light",
            display: "flex",
            borderRadius: "0 16px 16px 0",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            style={{
              width: "70px",
              // height: "100%",
            }}
            src={Check3d}
            alt=""
          />
        </Box>
      </Grid>
      <Grid item xs={9}>
        <Box
          sx={{
            backgroundColor: "background.default",
            borderRadius: "16px 0 0 16px",
            paddingY: "8px",
            paddingX: "4px",
            //   border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            تکمیل اطلاعات حساب
          </Typography>
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            توضیح درباره این ماموریت که در این قسمت قرارخواهد گرفت و ممکن است
            طولانی باشد{" "}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                paddingX: "8px",
                paddingY: "8px",
                borderRadius: "8px",
                width: "fit-content",
                backgroundColor: "#424242",
              }}
            >
              <img width={18} src={KarenCoin} alt="" />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                }}
                color={"#FFD54F"}
              >
                47
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                }}
                color={"#FFD54F"}
              >
                کارن پوینت
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "error.light",
                gap: "4px",
                padding: "4px",
                borderRadius: "6px",
              }}
            >
              <ClockOutline size={14} color={theme.palette.error.main} />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "error.main",
                    fontSize: "12px",
                  }}
                >
                  مهلت:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",

                    color: "error.main",
                  }}
                >
                  23:59:41
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",

                    color: "error.main",
                  }}
                >
                  و 2 روز
                </Typography>
              </Box>
            </Box>
          </Box>
          <Link
            to={"#"}
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: theme.palette.primary.main,
              padding: "8px",
              justifyContent: "center",
              gap: "6px",
              borderRadius: "8px",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontWeight: "600",
              }}
            >
              {"جستجو و دریافت بار"}
            </Typography>
            <ArrowLeftCircle color={"#fff"} />
          </Link>
        </Box>
      </Grid>
    </Grid>
  );
}
